// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AlertController from "./alert_controller"
application.register("alert", AlertController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import ConfirmModalController from "./confirm_modal_controller"
application.register("confirm-modal", ConfirmModalController)

import DiscountController from "./discount_controller"
application.register("discount", DiscountController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import EmailController from "./email_controller"
application.register("email", EmailController)

import ExclusiveController from "./exclusive_controller"
application.register("exclusive", ExclusiveController)

import FormularioController from "./formulario_controller"
application.register("formulario", FormularioController)

import GameSearchController from "./game_search_controller"
application.register("game-search", GameSearchController)

import GamecheckController from "./gamecheck_controller"
application.register("gamecheck", GamecheckController)

import HasAdvanceController from "./has_advance_controller"
application.register("has-advance", HasAdvanceController)

import HasDifferentPercentController from "./has_different_percent_controller"
application.register("has-different-percent", HasDifferentPercentController)

import IpController from "./ip_controller"
application.register("ip", IpController)

import IpReportTotalAmountModalController from "./ip_report_total_amount_modal_controller"
application.register("ip-report-total-amount-modal", IpReportTotalAmountModalController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import ModuleFilterController from "./module_filter_controller"
application.register("module-filter", ModuleFilterController)

import PermissionBulkSelectController from "./permission_bulk_select_controller"
application.register("permission-bulk-select", PermissionBulkSelectController)

import PermissionCollapseController from "./permission_collapse_controller"
application.register("permission-collapse", PermissionCollapseController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import ObjectiveOperatorController from "./objective_operator_controller"
application.register("objective-operator", ObjectiveOperatorController)

import OperatorinfoController from "./operatorinfo_controller"
application.register("operatorinfo", OperatorinfoController)

import PreventEnterController from "./prevent_enter_controller"
application.register("prevent-enter", PreventEnterController)

import PromoDiscountController from "./promo_discount_controller"
application.register("promo-discount", PromoDiscountController)

import RenewalIpController from "./renewal_ip_controller"
application.register("renewal-ip", RenewalIpController)

import RenewalsController from "./renewals_controller"
application.register("renewals", RenewalsController)

import SapInvoiceFiltersController from "./sap_invoice_filters_controller"
application.register("sap-invoice-filters", SapInvoiceFiltersController)

import SapInvoiceMonthFiltersController from "./sap_invoice_month_filters_controller"
application.register("sap-invoice-month-filters", SapInvoiceMonthFiltersController)

import SapPrepareModalController from "./sap_prepare_modal_controller"
application.register("sap-prepare-modal", SapPrepareModalController)

import SapXmlEditorController from "./sap_xml_editor_controller"
application.register("sap-xml-editor", SapXmlEditorController)

import SapInvoiceSendController from "./sap_invoice_send_controller"
application.register("sap-invoice-send", SapInvoiceSendController)

import SapOperatorTabsController from "./sap_operator_tabs_controller"
application.register("sap-operator-tabs", SapOperatorTabsController)

import ReportsController from "./reports_controller"
application.register("reports", ReportsController)

import SearchOperatorController from "./search_operator_controller"
application.register("search-operator", SearchOperatorController)

import SearchSelect2Controller from "./search_select_2_controller"
application.register("search-select-2", SearchSelect2Controller)

import SuperiorBonusController from "./superior_bonus_controller"
application.register("superior-bonus", SuperiorBonusController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import TogglebuttonController from "./togglebutton_controller"
application.register("togglebutton", TogglebuttonController)
